import { Account, AccountLevel } from "../Modules/Account/Model/Account";
import { User } from "../Modules/User/Model/User";

const levelKor: Record<AccountLevel, string> = {
  ADMIN: "어드민",
  DISTRIBUTOR: "총판",
  AGENCY: "대행사",
  SELLER: "셀러",
};

/**
 * 특정 ID를 기반으로 이름(등급 포함 가능)을 반환합니다.
 * @param accounts 전체 계정 목록
 * @param id 찾을 계정 ID
 * @param showGrade true면 이름(등급), false면 이름만 반환
 * @returns 이름 또는 이름(등급), 없으면 '-'
 */
export function getAccountNameById(
  accounts: Account[],
  id: number | undefined | null,
  showGrade: boolean = false,
  myAccount: User | null
): string {
  if (!id) {
    return "-";
  } else if (myAccount && id === myAccount.id) {
    return myAccount.name;
  } else {
    const account = accounts.find((acc) => acc.id === id);
    if (!account) {
      return "-";
    } else {
      return showGrade
        ? `${account.name} (${levelKor[account.grade] ?? account.grade})`
        : account.name;
    }
  }
}


/**
 * 특정 ID를 기반으로 이름(등급 포함 가능)을 반환합니다.
 * @param accounts 전체 계정 목록
 * @param id 찾을 계정 ID
 * @param showGrade true면 이름(등급), false면 이름만 반환
 * @returns 이름 또는 이름(등급), 없으면 '-'
 */
export function getAccountIdById(
  accounts: Account[],
  id: number | undefined | null,
  showGrade: boolean = false,
  myAccount: User | null
): string {
  if (!id) {
    return "-";
  } else if (myAccount && id === myAccount.id) {
    return myAccount.username;
  } else {
    const account = accounts.find((acc) => acc.id === id);
    if (!account) {
      return "-";
    } else {
      return showGrade
        ? `${account.username} (${levelKor[account.grade] ?? account.grade})`
        : account.username;
    }
  }
}
